const initialState = {
    showModal: null,
    showListOptions: false,
    product: {},
    type: null,
};

export default function productModalManager( state = initialState, action ) {
    switch ( action.type ) {
        case 'UPDATE_PRODUCT_MODAL':
            return {
                ...state,
                ...action.newState,
            };
        case 'COMPLEX_UPDATE_PRODUCT_MODAL':
            var newProduct = { ...state.product, ...action.newState.product };
            return {
                ...state,
                ...action.newState,
                product: newProduct,
            };
        case 'CLOSE_PRODUCT_MODAL':
            return {
                ...initialState,
            };
        case 'LOOKUP_PRODUCT_MODAL':
            return {
                ...initialState,
                showModal: 'lookupModal',
            };
        default:
            return state;
    }
}
